import React, { useEffect, useRef, useState, useMemo } from 'react';
import SkillSelector from '../features/SkillSelector';
import PlatformSelector from '../features/PlatformSelector';
import ImageUploadBox from '../common/ImageUploadBox';
import { SKILL_CATEGORIES } from '../../services/skillService';
import ContentPreviewModal from '../modals/ContentPreviewModal';
import { ChevronDown, Loader2 } from 'lucide-react';

const curatedPosts = [
  {
    id: 'xhs-1',
    image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=900&q=80',
    title: '7天素颜底妆打卡',
    desc: '黄皮通勤妆容合集，5分钟出门也能看起来气色很好。',
    author: '蜜桃乌龙酱',
    content: '早八通勤人请直接抄作业：粉底只上半张脸，另一半用气垫过渡，最后薄扫杏色腮红。全程轻薄不假面，办公室灯光下也不显脏。\n\n适合黄一白到黄二白，鼻翼和嘴角用小号遮瑕刷点压，妆感会更干净。\n\n#通勤妆容 #黄皮显白 #素颜感底妆',
    images: [
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=900&q=80',
      'https://images.unsplash.com/photo-1526045431048-f857369baa09?w=900&q=80',
      'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=900&q=80',
    ],
  },
  {
    id: 'xhs-2',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=900&q=80',
    title: '一周减脂午餐盒',
    desc: '600kcal内搭配模板，打工人也能稳定执行的轻食计划。',
    author: '吃不胖研究所',
    content: '分享我本周最稳的午餐盒公式：主食拳头大小 + 双份蔬菜 + 掌心蛋白质。\n\n周一到周五都按这个思路配，外卖也能套模板，饱腹感和体重都更稳定。\n\n#减脂饮食 #午餐便当 #健康生活',
    images: [
      'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=900&q=80',
      'https://images.unsplash.com/photo-1482049016688-2d3e1b311543?w=900&q=80',
      'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=900&q=80',
    ],
  },
  {
    id: 'xhs-3',
    image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=900&q=80',
    title: 'AI副业工具流',
    desc: '从选题到封面图的一整套工作流，个人号也能高频更新。',
    author: '阿宁的效率实验室',
    content: '把最近在用的 AI 内容生产流梳理成 4 步：选题库、结构化提纲、正文润色、封面统一模板。\n\n核心是把每一步做成可复用 SOP，不要每次从零开始。\n\n#AI工具 #内容创作 #副业增长',
    images: [
      'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=900&q=80',
      'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?w=900&q=80',
      'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=900&q=80',
    ],
  },
  {
    id: 'xhs-4',
    image: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=900&q=80',
    title: '周末城市慢逛路线',
    desc: '半天可走完的拍照路线，咖啡店和展览点位都整理好了。',
    author: 'CityWalk小周',
    content: '这条 CityWalk 真的适合新手：地铁直达，整体 4 公里，沿路有 3 个可出片点位。\n\n建议下午 4 点后出发，逆光拍人像更柔和。\n\n#城市漫步 #周末去哪儿 #出片路线',
    images: [
      'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=900&q=80',
      'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=900&q=80',
      'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=900&q=80',
    ],
  },
  {
    id: 'xhs-5',
    image: 'https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=900&q=80',
    title: '租房改造低预算',
    desc: '300 元以内把卧室氛围拉满，清单和尺寸都可直接抄。',
    author: '木子小窝',
    content: '租房党也能做氛围改造：先统一色温，再用布艺和地毯做层次，最后补一个角落灯。\n\n预算低但变化非常大，拍照也更高级。\n\n#租房改造 #卧室布置 #低预算家居',
    images: [
      'https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=900&q=80',
      'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=900&q=80',
      'https://images.unsplash.com/photo-1484101403633-562f891dc89a?w=900&q=80',
    ],
  },
  {
    id: 'xhs-6',
    image: 'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=900&q=80',
    title: '年度回购护肤单',
    desc: '敏感肌真实空瓶记录，按晨间/晚间完整拆解使用顺序。',
    author: 'Mia护肤笔记',
    content: '把我今年真空瓶的产品按「保湿、修护、提亮」分组了，敏感期也能用。\n\n顺序比单品更重要：先舒缓再叠加功效，皮肤稳定很多。\n\n#护肤空瓶 #敏感肌 #护肤流程',
    images: [
      'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=900&q=80',
      'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=900&q=80',
      'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=900&q=80',
    ],
  },
  {
    id: 'xhs-7',
    image: 'https://images.unsplash.com/photo-1517849845537-4d257902454a?w=900&q=80',
    title: '宠物拍照姿势模板',
    desc: '室内低光也能拍清楚，三步出片的构图方式合集。',
    author: '毛球摄影记',
    content: '宠物拍照别急着按快门，先让它看向你手里的零食，再连拍抓动态。\n\n手机人像模式 + 侧逆光，毛发会很有层次。\n\n#萌宠日常 #宠物拍照 #手机摄影',
    images: [
      'https://images.unsplash.com/photo-1517849845537-4d257902454a?w=900&q=80',
      'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=900&q=80',
      'https://images.unsplash.com/photo-1517423440428-a5a00ad493e8?w=900&q=80',
    ],
  },
  {
    id: 'xhs-8',
    image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=900&q=80',
    title: '快手早餐备餐法',
    desc: '3 组万能搭配，早上 10 分钟内搞定营养早餐。',
    author: '早起星人Vicky',
    content: '忙碌工作日建议固定 3 套早餐模板：酸奶碗、全麦三明治、燕麦杯。\n\n前一晚准备 80%，早上只需要 10 分钟，连续执行无压力。\n\n#早餐打卡 #上班族饮食 #备餐思路',
    images: [
      'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=900&q=80',
      'https://images.unsplash.com/photo-1484723091739-30a097e8f929?w=900&q=80',
      'https://images.unsplash.com/photo-1506084868230-bb9d95c24759?w=900&q=80',
    ],
  },
];

const CreationPanel = ({ prefillTopic = '', onGenerate: onGenerateExternal, isLoggedIn = false }) => {
  const fileInputRef = useRef(null);
  const uploadBoxRef = useRef(null);
  const galleryRef = useRef(null);
  const autoScrollRef = useRef(null);
  const [activePlatform, setActivePlatform] = useState(() => localStorage.getItem('creation_active_platform') || 'xiaohongshu');
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedImage, setUploadedImage] = useState('');
  const [uploadedImageUrl, setUploadedImageUrl] = useState('');
  const [previewPost, setPreviewPost] = useState(null);

  const [params, setParams] = useState({
    topic: '',
    pageCount: 1,
    style: localStorage.getItem('creation_active_style') || 'xiaohongshu_default',
  });
  const [isPageDropdownOpen, setIsPageDropdownOpen] = useState(false);

  useEffect(() => {
    if (prefillTopic) {
      setParams((prev) => ({ ...prev, topic: prefillTopic }));
    }
  }, [prefillTopic]);

  const skillOptions = useMemo(() => {
    const cat = SKILL_CATEGORIES[activePlatform];
    return cat ? cat.skills.map(s => ({ id: s.id, name: s.name, description: s.description })) : [];
  }, [activePlatform]);

  useEffect(() => {
    // 平台切换时，如果当前样式不属于该平台，切换到平台默认
    if (!params.style.startsWith(activePlatform)) {
      const defaultStyle = SKILL_CATEGORIES[activePlatform]?.skills[0]?.id;
      if (defaultStyle) {
        setParams(prev => ({ ...prev, style: defaultStyle }));
        localStorage.setItem('creation_active_style', defaultStyle);
      }
    }
    localStorage.setItem('creation_active_platform', activePlatform);
  }, [activePlatform, params.style]);

  const handleGenerate = () => {
    if (!params.topic || isLoading) return;
    if (onGenerateExternal) {
      onGenerateExternal({ topic: params.topic, title: params.topic, pageCount: params.pageCount, style: params.style });
    }
  };

  // Auto-scroll gallery
  useEffect(() => {
    autoScrollRef.current = setInterval(() => {
      if (galleryRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = galleryRef.current;
        if (scrollLeft + clientWidth >= scrollWidth - 10) {
          galleryRef.current.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          galleryRef.current.scrollBy({ left: 260, behavior: 'smooth' });
        }
      }
    }, 3000);
    return () => clearInterval(autoScrollRef.current);
  }, []);

  const PLATFORM_THEMES = {
    xiaohongshu: {
      primary: '#FF2442',
      gradient: 'from-[#FF2442] to-[#FF4D6D]',
      shadow: 'shadow-red-100',
      text: 'text-[#FF2442]',
      bg: 'bg-red-50/30'
    },
    wechat: {
      primary: '#07C160',
      gradient: 'from-[#07C160] to-[#10D672]',
      shadow: 'shadow-green-100',
      text: 'text-[#07C160]',
      bg: 'bg-green-50/30'
    }
  };

  const currentTheme = PLATFORM_THEMES[activePlatform] || PLATFORM_THEMES.xiaohongshu;

  return (
    <div className="animate-fade-in space-y-12 pt-6">
      <div className="mx-auto w-full max-w-5xl px-4 md:px-0">
        <div className="mb-10 space-y-4 text-center">
          <h1 className="text-4xl font-black tracking-tight text-[#1F2329] md:text-6xl">
            <span className="text-[#2563EB]">AI</span> 多平台灵感工坊
          </h1>
          <p className="text-lg font-medium text-gray-400">选择平台，一键生成符合渠道特性的爆款文案</p>
        </div>

        <div className="bg-white/70 backdrop-blur-2xl rounded-[32px] shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-white/80 p-6 relative z-10 hover:shadow-[0_30px_60px_rgba(0,0,0,0.08)] transition-all duration-500">
          {/* Top: Upload + Textarea */}
          <div className="flex gap-8 mb-6 items-start">
            <div className="flex-shrink-0 transition-transform duration-300 hover:scale-[1.02] pt-1">
              <ImageUploadBox
                ref={uploadBoxRef}
                uploadedImage={uploadedImage}
                setUploadedImage={setUploadedImage}
                setUploadedImageUrl={setUploadedImageUrl}
                isLoggedIn={true}
                onLoginRequired={() => { }}
              />
            </div>

            <div className="flex-1 relative group">
              <textarea
                value={params.topic}
                onChange={(e) => {
                  if (e.target.value.length <= 1500) setParams((prev) => ({ ...prev, topic: e.target.value }));
                }}
                placeholder="描述你想生成的文案主题或粘贴相关灵感内容..."
                className="w-full h-32 resize-none outline-none text-gray-800 text-xl placeholder-gray-300 bg-transparent leading-relaxed p-0 pt-1 transition-all"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    handleGenerate();
                  }
                }}
              />
              <div className="absolute bottom-1 right-0 text-xs font-bold text-gray-300 bg-white/50 px-2.5 py-1 rounded-full backdrop-blur-sm border border-gray-50/50">
                <span className={params.topic.length > 0 ? 'text-[#2563EB]' : ''}>{params.topic.length}</span> / 1500
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="h-px bg-gray-100 my-2"></div>

          {/* Divider */}
          <div className="h-px bg-gray-100/60 mb-6"></div>

          {/* Bottom Toolbar */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              {/* Platform Selector */}
              <PlatformSelector
                value={activePlatform}
                onChange={setActivePlatform}
                label="选择平台"
                size="default"
                direction="up"
              />

              {/* Style Selector */}
              <SkillSelector
                value={params.style}
                onChange={(s) => {
                  setParams(p => ({ ...p, style: s }));
                  localStorage.setItem('creation_active_style', s);
                }}
                options={skillOptions}
                label="创作风格"
                size="default"
                direction="up"
              />

              <div className="h-8 w-px bg-gray-100/80 mx-1"></div>

              {/* Page Count Selection (Custom UI) */}
              <div className="relative">
                <button
                  onClick={() => setIsPageDropdownOpen(!isPageDropdownOpen)}
                  className="flex items-center gap-2.5 px-3.5 py-2 rounded-2xl bg-gray-50/50 border border-transparent hover:border-gray-200 hover:bg-white transition-all text-sm group"
                >
                  <span className="text-gray-400 font-medium whitespace-nowrap">页数</span>
                  <span className="text-gray-900 font-bold min-w-[12px] text-center">{params.pageCount}</span>
                  <ChevronDown className={`h-4 w-4 text-gray-400 transition-transform duration-300 ${isPageDropdownOpen ? 'rotate-180' : ''}`} />
                </button>

                {isPageDropdownOpen && (
                  <>
                    <div className="fixed inset-0 z-50" onClick={() => setIsPageDropdownOpen(false)} />
                    <div className="absolute bottom-full mb-3 left-0 z-[60] bg-white/95 backdrop-blur-xl rounded-2xl border border-gray-100 shadow-[0_20px_40px_rgba(0,0,0,0.12)] p-1.5 min-w-[100px] animate-in fade-in slide-in-from-bottom-2 duration-300">
                      <p className="text-[10px] font-bold text-gray-300 px-3 py-1 uppercase tracking-widest border-b border-gray-50 mb-1 text-center">选择页数</p>
                      {[1, 3, 5, 7, 9].map((num) => (
                        <button
                          key={num}
                          onClick={() => {
                            setParams(prev => ({ ...prev, pageCount: num }));
                            setIsPageDropdownOpen(false);
                          }}
                          className={`
                            w-full flex items-center justify-between px-3.5 py-2.5 rounded-xl text-sm font-bold transition-all
                            ${params.pageCount === num ? 'bg-blue-50 text-[#2563EB]' : 'text-gray-600 hover:bg-gray-50'}
                          `}
                        >
                          <span>{num} 页</span>
                          {params.pageCount === num && <div className="w-1.5 h-1.5 rounded-full bg-[#2563EB]" />}
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>

              {/* Credits Display */}
              <div className="flex flex-col border-l border-gray-100/80 pl-5 py-0.5 justify-center">
                <div className="flex items-baseline gap-1.5 leading-none">
                  <span className="text-15px font-black text-[#2563EB]">~{(params.pageCount || 1) * 7}</span>
                  <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">积分</span>
                </div>
                <span className="text-[10px] text-gray-400 font-bold mt-1.5 whitespace-nowrap">预计单次消耗</span>
              </div>
            </div>

            {/* Generate Button */}
            <button
              onClick={handleGenerate}
              disabled={isLoading || !params.topic}
              className={`
                h-12 pl-6 pr-4 rounded-2xl font-bold text-white text-base
                flex items-center gap-4 transition-all duration-300 
                relative overflow-hidden group shadow-xl
                ${isLoading || !params.topic
                  ? 'bg-gray-200 cursor-not-allowed shadow-none text-gray-400'
                  : 'bg-gradient-to-r from-[#2563EB] to-[#3B82F6] hover:shadow-blue-200 hover:shadow-2xl hover:scale-[1.02] active:scale-[0.98]'
                }
              `}
            >
              {isLoading ? (
                <>
                  <Loader2 className="h-5 w-5 animate-spin" />
                  <span className="pr-3">正在生成...</span>
                </>
              ) : (
                <>
                  <span className="tracking-wide">{isLoggedIn ? '生成' : '登录并生成'}</span>
                  <div className="flex items-center gap-1.5 bg-black/10 backdrop-blur-md px-3 py-1.5 rounded-xl text-xs font-black border border-white/10 group-hover:bg-black/20 transition-all">
                    <svg className="w-4 h-4 text-yellow-300 drop-shadow-[0_0_8px_rgba(253,224,71,0.5)]" viewBox="0 0 24 24" fill="currentColor"><path d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                    <span className="text-white">{(params.pageCount || 1) * 7}</span>
                  </div>
                </>
              )}
              {/* Shine effect */}
              {!isLoading && params.topic && (
                <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-20 group-hover:animate-shine" />
              )}
            </button>
          </div>
        </div>


      </div>

      {/* Curated Gallery - Horizontal Auto-Scroll */}
      <div className="mt-16 mx-auto max-w-5xl pb-6">
        <h3 className="text-lg font-bold text-gray-900 mb-1 flex items-center px-1">
          <svg className="w-5 h-5 text-yellow-500 mr-2" viewBox="0 0 24 24" fill="currentColor"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" /></svg>
          热门精选
        </h3>
        <div className="relative group/gallery">
          <div
            ref={galleryRef}
            className="flex overflow-x-auto pb-6 gap-4 -mx-4 px-4 snap-x snap-mandatory"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            onMouseEnter={() => { if (autoScrollRef.current) clearInterval(autoScrollRef.current); }}
            onMouseLeave={() => {
              autoScrollRef.current = setInterval(() => {
                if (galleryRef.current) {
                  const { scrollLeft, scrollWidth, clientWidth } = galleryRef.current;
                  if (scrollLeft + clientWidth >= scrollWidth - 10) {
                    galleryRef.current.scrollTo({ left: 0, behavior: 'smooth' });
                  } else {
                    galleryRef.current.scrollBy({ left: 260, behavior: 'smooth' });
                  }
                }
              }, 3000);
            }}
          >
            {curatedPosts.map((post) => (
              <div
                key={post.id}
                className="flex-shrink-0 w-48 md:w-56 lg:w-60 aspect-[3/4] bg-gray-900 rounded-2xl overflow-hidden relative group cursor-pointer shadow-sm hover:shadow-xl transition-all hover:-translate-y-1 snap-center"
                onClick={() => setPreviewPost(post)}
              >
                <img src={post.image} alt={post.title} className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col justify-end p-4">
                  <p className="text-white text-sm font-bold line-clamp-1 mb-1 drop-shadow-md">{post.title}</p>
                  <p className="text-gray-300 text-[11px] font-medium line-clamp-2 leading-tight opacity-90">{post.desc}</p>
                  <p className="text-gray-200 text-[10px] mt-2">作者 @{post.author}</p>
                </div>
              </div>
            ))}
          </div>
          {/* Left Arrow */}
          <button
            onClick={() => galleryRef.current?.scrollBy({ left: -300, behavior: 'smooth' })}
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white shadow-lg rounded-full p-2 z-10 opacity-0 group-hover/gallery:opacity-100 transition-opacity duration-300 -ml-2"
          >
            <svg className="w-5 h-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
          </button>
          {/* Right Arrow */}
          <button
            onClick={() => galleryRef.current?.scrollBy({ left: 300, behavior: 'smooth' })}
            className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white shadow-lg rounded-full p-2 z-10 opacity-0 group-hover/gallery:opacity-100 transition-opacity duration-300 -mr-2"
          >
            <svg className="w-5 h-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-12 pb-8 text-center text-xs text-gray-300 space-y-1">
        <p>Copyright © 2025 ContentOS Pro. All rights reserved.</p>
        <div className="flex items-center justify-center gap-2">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-gray-400 hover:text-gray-600 transition-colors"
          >
            {'\u9ed4ICP\u59072025060431\u53f7-1'}
          </a>
          <span className="text-xs text-gray-400">|</span>
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=52019002007461"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 transition-colors"
          >
            <img src="/wabeian.png" alt={'\u516c\u5b89\u7f51\u5907'} className="w-4 h-4" />
            <span>{'\u8d35\u516c\u7f51\u5b89\u590752019002007461\u53f7'}</span>
          </a>
        </div>
      </div>

      <ContentPreviewModal
        open={Boolean(previewPost)}
        onClose={() => setPreviewPost(null)}
        title={previewPost?.title || ''}
        plainText={previewPost?.content || previewPost?.desc || ''}
        channel="xiaohongshu"
        images={previewPost?.images || (previewPost?.image ? [previewPost.image] : [])}
        authorName={previewPost?.author || 'ContentOS'}
      />
    </div>
  );
};

export default CreationPanel;
